'use strict';

var sanitize = require('./stringSanitizer');

/**
 * Formats a product to match the dataLayer requirements.
 * @param {object} product - The product to apply a correct dataLayer format.
 * @returns {object} The formatted product.
 */
function productFormatted(product) {
    let item = {
        item_id: product.id,
        item_name: sanitize.normalizeString(product.name),
        price: Number(parseFloat(product.price).toFixed(2)),
        quantity: parseInt(product.qty, 10)
    };

    if (product.brand) {
        item.item_brand = sanitize.normalizeString(product.brand);
    }

    if (Object.hasOwnProperty.call(product, 'is_subscribed')) {
        item.is_subscribed = String(product.is_subscribed);
    }

    if (product.categoryPath && product.categoryPath.length > 0) {
        var categories = product.categoryPath.split('/', 5);
        for (var i = 0; i < categories.length; i++) {
            item[`item_category${i === 0 ? '' : `${i + 1}`}`] = sanitize.normalizeString(categories[i]);
        }
    }

    if (product.discount) {
        item.discount = Number(parseFloat(product.discount).toFixed(2));
    }

    if (product.promotionId) {
        item.promotion_id = sanitize.normalizeString(product.promotionId);
    }

    if (product.promotionName) {
        item.promotion_name = sanitize.normalizeString(product.promotionName);
    }

    if (product.couponCode) {
        item.coupon = product.couponCode;
    }

    return item;
}

module.exports = { productFormatted };
